<template>
  <nav class="sidebar-nav test">
    <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-scroll-y="scrollHandle">
      <ul class="nav" id="navigations">
        <template v-for="(item, index) in navItems">
          <template v-if="item.divider">
            <SidebarNavDividerIS :key="index" :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabelIS :key="index" :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children" >
              <!-- First level dropdown -->
              <SidebarNavDropdownIS :key="index" :name="item.name" :url="item.url" :icon="item.icon" :childs="'1'" >
                <template v-for="(childL1, index1) in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdownIS :key="index1" :name=" childL1.name" :url="childL1.url" :icon="childL1.icon" :childs="'2'">
                      <li :key="index2" class="nav-item" v-for="(childL2, index2) in childL1.children" >
                        <SidebarNavLinkIS :first="'3'" :name=" childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="childL2.variant" :attributes="childL2.attributes" />
                      </li>
                    </SidebarNavDropdownIS>
                  </template>
                  <template v-else>
                    <SidebarNavItemIS :key="index1" :classes="item.class">
                      <SidebarNavLinkIS :first="'2'" :name=" childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="childL1.variant" :attributes="childL1.attributes" />
                    </SidebarNavItemIS>
                  </template>
                </template>
              </SidebarNavDropdownIS>
            </template>
            <template v-else>
              <SidebarNavItemIS :key="index" :classes="item.class" >
                <SidebarNavLinkIS :first="'1'" :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant" :attributes="item.attributes"/>
              </SidebarNavItemIS>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </VuePerfectScrollbar>
  </nav>
</template>

<script>
  import SidebarNavDividerIS from './SidebarNavDividerIS'
  import SidebarNavDropdownIS from './SidebarNavDropdownIS'
  import SidebarNavLinkIS from './SidebarNavLinkIS'
  import SidebarNavTitleIS from './SidebarNavTitleIS'
  import SidebarNavItemIS from './SidebarNavItemIS'
  import SidebarNavLabelIS from './SidebarNavLabelIS'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    name: 'SidebarNav',
    components: {
      SidebarNavDividerIS,
      SidebarNavDropdownIS,
      SidebarNavLinkIS,
      SidebarNavTitleIS,
      SidebarNavItemIS,
      SidebarNavLabelIS,
      VuePerfectScrollbar
    },
    props: {
      navItems: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data () {
      return {}
    },
    computed: {
      psSettings: () => {

        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    methods: {
      scrollHandle (evt) {

      },

    }
  }
</script>

<style scoped lang="css">
  .scroll-area {
    position: absolute;
    height: 100%;
    margin: auto;
  }


</style>
